export default __webpack_public_path__ + "assets/default.d70ec380.jpg";